import { useQuery } from "@tanstack/react-query";
import { artefactsApi } from "../api/artefacts";
import { formatApiEndDate, formatApiStartDate } from "../../../shared/utils";

export interface ArtefactsFetchFilters {
    projectId?: string;
    stageGateId: number | null;
    page: number;
    limit: number;
    searchKey: string | null;
    assignedToMe: boolean;
    statusFilter?: string[];
    categoryFilter?: string[];
    subCategoryFilter?: string[];
    ownerFilter?: string[];
    portfolioFilter?: string[];
    projectFilter?: string[];
    phaseFilter?: string[];
    dateFrom?: string | undefined | Date;
    dateTo?: string | undefined|Date;
}

export const useFetchArtefacts = ({
    projectId, stageGateId, page, limit, searchKey, assignedToMe,
    statusFilter, categoryFilter, subCategoryFilter, ownerFilter,
    portfolioFilter, projectFilter, phaseFilter, dateFrom, dateTo,
}: ArtefactsFetchFilters) => {

    const effectiveProjectId = projectId ?? (projectFilter?.length === 1 ? projectFilter[0] : undefined);

    const { data, isFetching, isPending, isError, refetch } = useQuery({
        queryKey: [
            "artefact-document",
            projectId, stageGateId, page, limit, searchKey, assignedToMe,
            statusFilter, categoryFilter, subCategoryFilter, ownerFilter,
            portfolioFilter, projectFilter, phaseFilter, dateFrom, dateTo,
        ],
        queryFn: () => artefactsApi.fetchArtefacts({
            params: {
                page,
                limit,
                search_term: searchKey,
                project_id: projectId ?? (projectFilter?.length ? projectFilter : undefined),
                stage_gate_id: stageGateId,
                assign_to_me: assignedToMe,
                status: statusFilter?.length ? statusFilter : undefined,
                category: categoryFilter?.length ? categoryFilter : undefined,
                sub_category: subCategoryFilter?.length ? subCategoryFilter : undefined,
                owner_id: ownerFilter?.length ? ownerFilter : undefined,
                portfolio_id: portfolioFilter?.length ? portfolioFilter : undefined,
                project_tree_id: phaseFilter?.length ? phaseFilter : undefined,
                start_date: dateFrom ? formatApiStartDate(dateFrom) : undefined,
                end_date: dateTo ? formatApiEndDate(dateTo) : undefined,
            },
        }),
    });

    return {
        artefactsData: data?.data?.rows,
        artefactsPagination: data?.data?.pagination,
        isPending, isFetching, isError,
        refetch: refetch
    }

};